import React, {useReducer} from 'react';
import { useHistory } from "react-router-dom";
import gql from 'graphql-tag';

import {
  USERS_CONNECTION_QUERY
} from '../api/homepage'

import { handleArtistClick } from '../utils'
import { colors, fontSizes} from '../styles/defaultTheme';
import ErrorPage from '../components/ErrorPage';
import Header from '../components/Header';
import RecommendedUser from '../components/RecommendedUser';
import Footer from '../components/Footer';
import Button from '../components/Button';

import WindowSizeListener from 'react-window-size-listener'
import { Helmet } from "react-helmet";
import MailchimpSubscribe from "react-mailchimp-subscribe"


import imagePlaceholder from '../images/blog-placeholder.png'
import userMsgIconDown from '../images/carrot-down.svg';
import userMsgIconUp from '../images/carrot-up.svg';
import favArtistStepMessage from '../images/favorite-artists-msg.svg';
import mobileFavArtistStepMessage from '../images/other-users-artists-mobile.svg';
import loadingIcon from '../images/load-disk.png';


import { useQuery, useMutation } from 'react-apollo-hooks';

const renderActionItems = (state, dispatch, history) => {
  const url = process.env.REACT_APP_MAILCHIMP_URL;

  const SimpleForm = () => <MailchimpSubscribe url={url}/>


  return (
    <div className="post-page__action-items">
      <Button
        handleclick={() => history.push('/get-access')}
        customClass="rating-artist__rate-btn post-page__cta-btn"
        gradient={true}
      >
        Sign Up To Rate & Explore
      </Button>
      <p className="post-page__action-items__split">- or subscribe for launch updates -</p>
      <div className="post-page__sub-container">
        <p className="post-page__action-items__title">Join Our Waitlist</p>
        <p className="post-page__action-items__msg">Rapchr is a new social platform being built for rap fans of all eras and styles, this is just a taste of what you can expect! Subscribe now for early access when the app is released.</p>
        <MailchimpSubscribe
          url={url}
          render={({ subscribe, status, message }) => {
            return (
              <div className="post-page__sub-wrapper">
                <SimpleForm  url={url} onSubmitted={formData => subscribe(formData)} />
                {status === "sending" && <div style={{ color: "#c77d4a", marginBottom: "20px" }}>sending...</div>}
                {status === "error" && <div style={{ color: "#722a1f" + 10, marginBottom: "20px" }} dangerouslySetInnerHTML={{__html: message}}/>}
                {status === "success" && <div style={{ color: "#c77d4a", marginBottom: "20px" }}>Subscribed !</div>}
              </div>
            )
          }}
        />
      </div>
    </div>
  )
}

const onResize = (windowSize, state, dispatch) => {

  if(windowSize.windowWidth < "900" && !state.mediumScreensize) {
    dispatch({payload: {mediumScreensize: true, showUsers: false}})
  } else if(windowSize.windowWidth > "900" && state.mediumScreensize) {
    dispatch({payload: {mediumScreensize: false, showUsers: false}})
  }
  if(windowSize.windowWidth < "768" && !state.smallScreensize) {
    dispatch({payload: {smallScreensize: true, showUsers: false}})
  } else if(windowSize.windowWidth > "768" && state.smallScreensize) {
    dispatch({payload: {smallScreensize: false, showUsers: false}})
  }
}

const handleUserScroll = (e, fetchMore, data, state, dispatch, setLoadingMore) => {
  const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
  if (bottom) {

    if(setLoadingMore) {
      setLoadingMore(true)
    } else {
      dispatch({payload: {loading: true}})
    }

    fetchMore({
      variables: {
        first: 20,
        cursor: data.usersConnection.pageInfo.endCursor
      },
      updateQuery: (prevResult, { fetchMoreResult }) => {
        const newEdges = fetchMoreResult.usersConnection.edges;
        const pageInfo = fetchMoreResult.usersConnection.pageInfo;

        if(setLoadingMore) {
          setLoadingMore(false)
        } else {
          dispatch({payload: {loading: false}})
        }
        return newEdges.length
        ? {
          usersConnection: {
            __typename: prevResult.usersConnection.__typename,
            edges: [...prevResult.usersConnection.edges, ...newEdges],
            pageInfo
          }
        }
        : prevResult
      }
    })
  }
}


const reducer = (state, action) => {
  switch (action.type) {
    default:
      return { ...state, ...action.payload };
  }
};

const initialState = () => ({
  smallScreensize: window.innerWidth <= 768,
  showUsers: false,
  loading: false
})

const Blog = ({match, currentUser, allSkills}) => {

  const [state, dispatch] = useReducer(reducer, initialState())

  const {
    data: recentUsers,
    loading: recentUsersLoading,
    error: recentUsersError,
    fetchMore
  } = useQuery(USERS_CONNECTION_QUERY, {
    variables: {
      first: 20,
    }
  })

  let history = useHistory();

  // if(loading) {
  //   return (
  //     <p>Loading</p>
  //   )
  // }
  //
  // if(error) {
  //   return <ErrorPage />
  // }


  return (
    <div className="blog-page">
      <Helmet>
        <title>About | Rapchr</title>
      </Helmet>
      <WindowSizeListener onResize={(windowSize) => onResize(windowSize, state, dispatch)}/>
      <Header
        customClass={state.smallScreensize && state.showUsers && "blur"}
        allSkills={allSkills}
        history={history}
        currentUser={currentUser}
        smallScreensize={state.smallScreensize}
      />
      <div style={{width: recentUsersError && "100%"}} className={`skill-step__left-hand blog-page__left-hand  ${state.smallScreensize && state.showUsers && "blur"}`}>
        <div className="left-hand__top-gradient"></div>
        <h2 className="blog-page__title">A Social Platform Dedicated to Rap</h2>
        <div style={{backgroundImage: `url(https://res.cloudinary.com/rapchr/image/upload/v1646933537/Slice_1_ychaup.png)`}} className="blog-page__main-image"></div>
        <div className="blog-page__content">
          <p className="blog-page__text-block">
          Those moments in life when you find that you’re not alone in your enjoyment of a song, album, or artist are ones we all love and look forward to. Especially when it comes to hip-hop, which has tradition baked into the culture that can create deep conversation and analysis on a global scale.          </p>
          <p className="blog-page__text-block">
          <b>We believe that fans and music lovers, more so than even sales charts or award shows, have been keeping the true record of the greatest minds in music.</b> As a genre and culture that doesn’t get the respect it deserves in too many ways, hip-hop's communal history keeping is especially important.
           </p>

          <p className="blog-page__text-block">
We’re building a place for rap fans who love to share their thoughts and passion for the music they enjoy or discover, with others. We’re taking the ways that the hip-hop community has always discussed and shared their thoughts, and creating a world designed to keep those traditions evolving in new and interesting ways.          </p>
          <p className="blog-page__text-block">
This is a just sneak peek of what Rapchr will be: not only social app for rap fans, but a platform dedicated to constructive discussion and analysis of great music. A celebration of the most influential genre in the world.          </p>
          <p className="blog-page__text-block">
          We hope that you enjoy what we’ve shared so far, and continue to follow us on our journey towards the full launch.
          </p>

        </div>
        {!currentUser &&  renderActionItems(state, dispatch, history)}
        <div className="bump"></div>
        <div className="left-hand__bottom-gradient"></div>
      </div>
      {((state.smallScreensize && state.showUsers) || !state.smallScreensize) &&
      <div
        style={{display: recentUsersError && "none"}}
        className="skill-step__right-hand"
        onScroll={(e) => handleUserScroll(e, fetchMore, recentUsers, state, dispatch)}
      >
        <div onClick={() => dispatch({payload: {showUsers: !state.showUsers}})} className="skill-step__mobile-users__cta__top">
          <img src={mobileFavArtistStepMessage} className="skill-step__msg-mobile" alt="Other user's favorite artists" />
          <img lt={state.showUsers ? "close" : "open"} src={state.showUsers ? userMsgIconDown : userMsgIconUp} className="skill-step__msg-icon" />
        </div>
        <div className="skill-step__top-gradient"></div>
        <div className="skill-step__users">
          {recentUsersLoading &&
            <div className="loading__wrapper">
              <img className="loading__icon" alt="loading" src={loadingIcon} />
            </div>
          }
          {recentUsers && recentUsers.usersConnection && recentUsers.usersConnection.edges.map((user, index) => {
            return (
              <RecommendedUser
                key={index}
                user={user.node}
                artists={true}
                index={index}
                currentUser={currentUser}
                recentUsersLoading={recentUsersLoading}
                onboarding={currentUser && (!currentUser.onboardedArtists || !currentUser.onboardedSkills)}
                onArtistClick={(artist) => handleArtistClick(artist, history)}
                customClass={state.loading ? " loading-more" : ""}
              />
            )
          })}
        </div>
        {state.loading && <div className="loading__wrapper user-profile__loading-wrapper right-hand">
          <img className="loading__icon" alt="loading" src={loadingIcon} />
        </div>}
        <div className="skill-step__bottom-gradient"></div>
        <div className="bump"></div>
      </div>}
      {!state.showUsers && <div onClick={() => dispatch({payload: {showUsers: !state.showUsers}})} className="skill-step__mobile-users__cta">
        <img src={mobileFavArtistStepMessage} className="skill-step__msg-mobile" alt="Other user's favorite artists" />
        <img alt={state.showUsers ? "close" : "open"} src={state.showUsers ? userMsgIconDown : userMsgIconUp} className="skill-step__msg-icon" />
      </div>}
      <Footer />
    </div>
  )
}


export default Blog
